/**
 * Convert d3.event.selection to {start: number, end:number}
 * @param selection
 * @param scale
 */
export default function (selection: number[], scale: { invert: (number) => number | Date }) {
    const [start, end] = selection
        .map(value => scale.invert(value))
        .map((value: number | Date) => {
            if (typeof value == 'number') {
                // depth span
                return Math.round(value)
            } else {
                return value.getTime()
            }
        })
        .sort((a, b) => a - b)

    // force start + 1 to keep span > 0
    return { start: start === 0 ? 1 : start, end: start == end ? start + 1 : end }
}
